module.exports = __webpack_public_path__ + "img/processing_icon.50e0e038.svg";